import { resourceCategoryFieldMapping } from "@qlik/qlik/src/lib/constants/resource-constants";
import { FUNCTIONS_PATH } from "@qlik/qlik/src/lib/constants/service-constants";
import { constructFilterQuery, fetchJsonResponse } from "@qlik/qlik/src/lib/services/util";

/**
 * Fetches a list of resources based on the provided filters.
 * Or can be used to fetch full list of category data.
 *
 * @async
 * @param {Object} filters - The filters to apply to the resource listing.
 * @param {Boolean} isFetchAll - Boolean parameter deciding whether to return full set of data with only category information - <b>NOTE: Contentful currently supports a maximum of MAX_LIMIT=1000 unpaginated items</b>.
 * @see {@link https://www.contentful.com/developers/docs/references/content-delivery-api/#/reference/search-parameters/limit limit docs}
 * @returns {Promise<Object>} The JSON response from the resource listing API.
 */
const fetchResourceListing = async (filters, env = "main", language = "English", locale = "en", preview = false) => {
    return fetchJsonResponse(
        `${
            process.env.GATSBY_LISTING_API
        }${FUNCTIONS_PATH}/resource-listing?env=${env}&language=${language}&locale=${locale}&preview=${preview}&${constructFilterQuery(
            filters,
            resourceCategoryFieldMapping
        )}`
    );
};

export { fetchResourceListing };
